// Operasional home (`/operations`): the operator's own location, phone first.
// Formal and calm, like the rest of the app: "Reader" (never "gateway"), "Titik Distribusi", no exclamation marks.

export const OPERATIONS_HOME = {
  actions: 'Tindakan',
  hubOrders: 'Pesanan',
  hubOrdersSub: (open: number | null, late: number | null) => (open === null ? 'Pesanan warga di Hub ini' : open === 0 ? 'Tidak ada pesanan berjalan' : `${open} pesanan berjalan${late ? `, ${late} lewat batas` : ''}`),
  hubCounter: 'Layanan di loket',
  hubCouriers: 'Kurir & setoran',
  hubCouriersSub: 'Rekap kurir dan setoran tunai harian',
  hubStockCount: 'Stock opname',
  hubStockCountSub: 'Hitung tabung di Hub dan bandingkan dengan catatan',
  hubCounterSub: 'Warga datang langsung tanpa aplikasi',
  hubHouseholds: 'Verifikasi Warga',
  hubHouseholdsSub: (n: number | null) => (n === null ? 'Pemeriksaan KTP dan KK warga' : n === 0 ? 'Tidak ada warga yang menunggu' : `${n} warga menunggu pemeriksaan`),
  newBadge: (n: number) => `${n} baru`,
  dispatchSub: 'Muat ke truk, Surat Jalan terbit otomatis',
  receiveSub: 'Bongkar dan cocokkan dengan Surat Jalan',
  registerSub: (warehouse: string) => `Daftarkan tabung baru di ${warehouse}`,
  registerOnly: (warehouse: string) => `Hanya di ${warehouse}`,
  registerOnlyTitle: (warehouse: string) => `Pendaftaran tabung hanya di ${warehouse}`,
  lookupSub: 'Lihat riwayat dan posisi tabung',
  incomingBadge: (n: number) => `${n} menuju`,
  /** the reader banner says what to do; the header pill already says what is wrong */
  readerDown: 'Periksa listrik dan jaringan Reader. Pembacaan tersimpan di Reader dan terkirim setelah tersambung kembali.',
  readerNone: 'Minta administrator menempatkan Reader di Titik Distribusi ini. Sementara itu tabung dapat dimuat dan diterima manual dengan nomor seri.',
  glance: 'Ringkasan hari ini',
  stock: 'Tabung di sini',
  inToday: 'Masuk hari ini',
  outToday: 'Keluar hari ini',
  today: 'Kiriman hari ini',
  out: 'Keluar',
  in: 'Masuk',
  todayEmpty: 'Belum ada kiriman hari ini.',
  emptyRegisterFirst: 'Daftarkan tabung terlebih dahulu, lalu kirim ke lokasi tujuan.',
  emptyDispatch: 'Tekan Kirim Tabung untuk membuat Surat Jalan pertama hari ini.',
  seeAll: 'Lihat semua Surat Jalan hari ini',
  cylinders: (n: string) => `${n} tabung`,
  demo: 'Demo',
  sep: ' · ',
  loadError: (e: string) => `Status kiriman di lokasi ini belum bisa dimuat. ${e}`,
  loading: 'Memuat status lokasi…',
  /** the Reader status card under the header (one card: what is wrong and what to do) */
  reader: {
    ok: (name: string) => `${name} tersambung`,
    tags: (n: string) => `${n} tag terbaca saat ini`,
    noTags: 'Siap membaca tag',
    attention: (name: string) => `${name} perlu perhatian`,
    down: (name: string) => `${name} terputus`,
    since: (at: string) => `Terakhir terhubung ${at}`,
    never: (name: string) => `${name} belum pernah terhubung`,
    neverSub: 'Reader belum pernah mengirim kabar ke sistem.',
    none: 'Belum ada Reader',
    noneSub: 'Titik Distribusi ini belum memiliki Reader.',
    more: (n: number) => `dan ${n} Reader lain`,
  },
  /** "Pembacaan terakhir": the latest tags read at this location's Reader */
  reads: 'Pembacaan terakhir',
  readsEmpty: 'Belum ada pembacaan. Dekatkan tag ke Reader.',
  readsOffline: 'Reader terputus. Daftar ini berisi pembacaan terakhir yang diterima.',
  registered: 'Terdaftar',
  unregistered: 'Belum terdaftar',
  /** a tag bound before (its chip or its EPC): never registered again, so never "Belum terdaftar" */
  usedBefore: (serial: string) => `Pernah dipakai ${serial}`,
  retired: 'Tidak berlaku',
  registerTag: 'Daftarkan',
  registerTagLabel: (epc: string) => `Daftarkan tag ${epc}`,
  readCount: (n: number) => `${n}× terbaca`,
  openCylinder: (serial: string) => `Buka tabung ${serial}`,
} as const;

/** Kirim Tabung step 1: the footer hint under "Mulai muat tabung", depending on the Reader here. */
export const DISPATCH_READER_HINT = {
  present: 'Reader langsung mulai membaca tabung yang lewat.',
  none: 'Belum ada Reader di Titik Distribusi ini, jadi tabung tidak terbaca otomatis. Tambahkan tabung dengan nomor seri pada langkah berikutnya.',
} as const;
